import $ from 'jquery';
import '@ungap/custom-elements';

// Scripts
import 'bootstrap-add-clear';
import 'bootstrap-notify';
import 'devbridge-autocomplete';
import 'jquery-mask-plugin';
import './js/jquery_formset.js';
import 'select2';
import './js/django_select2.js';

import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
import 'tinymce/plugins/autoresize';
import 'tinymce/plugins/colorpicker';
import 'tinymce/plugins/textcolor';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/save';
import 'tinymce/plugins/table';
import 'tinymce/plugins/paste';

import './js/knowx.js';
import {messageBox} from "./js/dialog";
import './js/account_create.js';
import './js/entry.js';
import './js/home.js';
import './js/pagination.js';
import './js/profile.js';
import './js/search.js';
import './js/users.js';

// Styles
import './css/app.scss';
import 'tinymce/skins/ui/oxide/content.min.css';
import 'tinymce/skins/ui/oxide/skin.min.css';

// Vue
import 'lazysizes'
import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/attrchange/ls.attrchange'
import Vue from 'vue'
import VueResource from 'vue-resource'
import vueCustomElement from 'vue-custom-element'
import lightbox from './vue/lightbox.vue'
import uploadbox from './vue/uploadbox.vue'

Vue.use(VueResource);
Vue.use(vueCustomElement);

Vue.customElement('knowx-lightbox', lightbox);
Vue.customElement('knowx-uploadbox', uploadbox);

window.isIE = !!document.documentMode // Internet Explorer 6-11
window.isEdge = !window.isIE && !!window.StyleMedia // Edge 20+

$(document).ready(function () {
  // display modal if browser is IE
  if (window.isIE) {
    document.querySelector('body').classList.add('browser-ie')
    messageBox( // title message action
      gettext('Warning'),
      gettext('Internet Explorer is not recommended for using this website. It is strongly advised to use' +
        ' Chrome or Firefox, for which our website is optimised.') +
      '<br><br>' +
      gettext('Furthermore, the EDQM pays particular attention to data protection. Therefore, we advise' +
        ' you not to use web browsers that are no longer up to date, are no longer supported by the publisher, have' +
        ' security flaws or are at the end of their life.\n') + '<br>',
      {'accept': 'I understand'},
      false)
  } else if (window.isEdge) {
    document.querySelector('body').classList.add('browser-edge')
  }
})
